"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UncollapsedLinks = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatID = _interopRequireDefault(require("../../../utils/formatID"));
var _lodash = require("lodash");
var _NavBar = require("../../NavBar/NavBar");
var _LunaLink = _interopRequireDefault(require("../../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const UncollapsedLinks = props => {
  const {
    link,
    menuProps
  } = props;
  const {
    collapsed,
    Link,
    mouseLeave
  } = menuProps;
  const {
    mouse
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const [open, setOpen] = (0, _react.useState)(null);
  const mouseOverFeature = feature => {
    setOpen(feature);
  };
  const classTag = link?.imageUrl ? "--image-description" : "--text";
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: link?.contentfulId
  }, link?.url && /*#__PURE__*/_react.default.createElement("div", {
    onMouseOver: () => mouseOverFeature(link?.contentfulId),
    onMouseLeave: () => {
      mouseOverFeature(null);
    },
    className: `ter-mega-menu__left-title ${link?.imageUrl ? "ter-mega-menu__left-title--image-content" : ""} ${open === link?.contentfulId && !link?.imageUrl ? "ter-mega-menu__left-title--is-open" : ""}`
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: link?.url,
    onClick: mouseLeave,
    Link: Link,
    tabIndex: mouse ? "" : "0",
    className: `ter-mega-menu__left-title ter-mega-menu__left-title${link?.imageUrl ? "--image" : "--link"} ${link?.imageUrl ? "ter-mega-menu__left-title--image-content" : ""}  ${mouse ? "" : "tabFocus"}`,
    target: typeof link?.external === 'boolean' ? link?.external ? "_blank" : "_self" : null,
    depth: 3,
    htmlTitle: `${link?.text?.length > 24 ? link?.text : ``}`
  }, link?.imageUrl && /*#__PURE__*/_react.default.createElement("img", {
    src: link?.imageUrl,
    alt: link?.altText ? link.altText : "",
    "aria-label": link?.url,
    className: mouse ? "ter-mega-menu__image" : "ter-mega-menu__image tabFocus"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: `ter-mega-menu__left-title${classTag} ${open === link?.contentfulId ? `ter-mega-menu__left-title${classTag}--is-hovered` : ""}
              ${link?.text?.length > 24 ? `ter-mega-menu__left-title--truncated` : ``}`
  }, link?.imageUrl && !collapsed ? link?.description : link?.text))));
};
exports.UncollapsedLinks = UncollapsedLinks;